import { useMemo, useDebugValue } from "react";
import { useCalculation } from "../context";
import { getInNamespaced, existsInNamespaced } from "../../calculator/utils";
import { fieldDef } from "./fieldDef";
export function useFieldData(namespaceOrField, fieldName) {
    const { namespace, name } = fieldDef(namespaceOrField, fieldName) ?? {};
    const [data] = useFieldsData(name != null ? { namespace, name } : undefined);
    useDebugValue(data);
    const { error, enabled, visible, fieldValue, exists, initialFieldValue } = data || {};
    const fieldData = useMemo(() => ({ error, enabled, visible, fieldValue, exists, initialFieldValue }), [error, enabled, visible, fieldValue, exists, initialFieldValue]);
    return fieldData;
}
export function useFieldsData(...fields) {
    const { errors, isEnabled, isFieldVisible, defaultFieldVisibility, defaultFieldEnabled, formValues, initialFormValues } = useCalculation("errors", "isEnabled", "isFieldVisible", "defaultFieldVisibility", "defaultFieldEnabled", "formValues", "initialFormValues");
    const data = fields.map(f => {
        if (!f)
            return undefined;
        const { namespace, name } = f;
        const error = getInNamespaced(errors, namespace, name);
        let enabled = getInNamespaced(isEnabled, namespace, name);
        if (enabled == null) {
            enabled = getInNamespaced(defaultFieldEnabled, namespace, name, true);
        }
        let visible = getInNamespaced(isFieldVisible, namespace, name);
        if (visible == null) {
            visible = getInNamespaced(defaultFieldVisibility, namespace, name, false);
        }
        const fieldValue = getInNamespaced(formValues, namespace, name);
        const initialFieldValue = getInNamespaced(initialFormValues, namespace, name);
        const exists = existsInNamespaced(formValues, namespace, name);
        return { error, enabled, visible, fieldValue, initialFieldValue, exists };
    });
    return data;
}
//# sourceMappingURL=useFieldData.js.map